import Orders from './DownloadOrders';
import Users from './DownloadUsers';
import Transactions from './DownloadTransaction';
import ShippingDetails from './DownloadShippingDetails';
import StorageDetails from './DownloadStorageDetails';
import UploadFormat from './DownloadUploadFormat';

export default {
    Orders,
    Users,
    ShippingDetails,
    StorageDetails,
    Transactions,
    UploadFormat
}